/* copied from c2Archive/dependentFields.js
 *
 * Form fields that are modified by other form field values.
 */
(function (__module__) {
  'use strict';

  var cuiMode;
  const logger = c2.logging.getLogger(__module__);

  function trimIfString(value) {
    if (value === null || value === undefined) {
      return "";
    }

    if (typeof(value) === "string") {
      return value.trim();
    } else {
      return value;
    }
  }


  function init($container) {
    /*
     $container = the individual form on which to activate the dependent fields. This can be a single service item form
     within a formset, a server or resource action form, or possibly other kinds of forms that support dependent fields
     in the future.
     */
    if ($container.hasClass("blueprint")) {
      // This is a blueprint service item. We do not initialize dependent field behavior on this service item, just on
      // its sub-service items.
      logger.debug("Skipping container", $container, "since it is a BP service item.")
      return;
    }
    // Set cuiMode
    cuiMode = getUIMode() === "cui";
    // Each container should have just one element with data-field-dependencies. PSSIs are a bit different and can have
    // two, we always want the last one. The first one is a div with classes "service-item", "nested", and "provserver".
    // If there are > 1 envs, there will also be a child div with class "runtime-inputs" that has
    // data-field-dependencies.
    // In both cases, the proper data-field-dependencies will be set on the last one, and the following line finds the
    // last one and reads its data-field-dependencies.
    let $fieldDeps = $container.find('[data-field-dependencies]').addBack('[data-field-dependencies]').last().attr('data-field-dependencies');
    if (!$fieldDeps || $fieldDeps == "") {
      $fieldDeps = "[]";
    } else {
      logger.debug("Processing container", $container, "and about to JSON parse the field dependencies: '" + $fieldDeps + "'");
    }
    let fieldDeps = JSON.parse($fieldDeps);
    createChangeHandlersForFieldDependencies(fieldDeps, $container);

    // Find the list of fields that should be populated when the form first displays.
    // The 'data-root-fields' attribute can appear in the container in a couple
    // different ways. Sometimes it comes on in the one passed to init, and
    // sometimes it comes in on one or more children of the container. Here's a
    // unified way to find them all in both cases. (find searches the container's
    // descendants, while addBack includes the container itself)
    const $form_divs = $container.find('[data-root-fields]').addBack('[data-root-fields]').map(function () {
      return $(this).attr('data-root-fields');
    }).get();

    // Find all fields the backend form Python code has determined that we should initially hide and do so
    const $fieldsToHide = $container.find("[initially-hide-dependent-field]");
    $.each($fieldsToHide, function(idx, fieldToHide) {
      logger.debug("Initially hiding", fieldToHide);
      showOrHideField(false, $(fieldToHide));
    })

    // Trigger a change event on any 'os_build' form fields,
    // for OS Family dependent fields to show or hide on initial form load.
    $("[id^='id_form-'][id$='-os_build']").each(function(idx, element) {
      $(element).trigger("controlFieldChanged");
    });
  }

  function getUIMode() {
    let mode = 'default'
    if ($('#id_ui_mode').length && $('#id_ui_mode')[0].value){
      mode = $('#id_ui_mode')[0].value
    }
    return mode
  }

  /**
   * Mark each of the dependent fields in fieldDeps as "changing", then recurse, setting all of their dependent fields
   * to "changing".
  */
  function changeFieldTreeStatuses(dependentFields, fieldDeps) {
    for (const depFieldName of dependentFields) {
      let depInfo = fieldDeps[depFieldName]
      if (depInfo.status != "missing") {
        depInfo.status = "changing";
        if (depInfo.dependent_fields != undefined) {
          // recurse to mark each of the dependent field's dependent fields as "changing"
          changeFieldTreeStatuses(depInfo.dependent_fields, fieldDeps);
        }
      }
    }
  }

  /**
   * A control field was changed by the user in the UI.
   * Block the form from further changes, set status=changing on all descendants,
   * then kick off an event that will cause all child fields to update themselves as appropriate.
   * @param {Array} dependentFields - a list of dependent field names for this controlling field.
   * @param {Object} fieldDeps - all field dependencies for this form
  */
  function controlFieldChangedByUser($container, $controlField, controlFieldName, dependentFields, fieldDeps) {
    logger.debug("Control field", $controlField.attr('id'), "was changed by the user. fieldDeps:", fieldDeps);

    logger.debug("Changing all children of", controlFieldName ,"to 'changing'");
    changeFieldTreeStatuses(dependentFields, fieldDeps);
    fieldDeps[controlFieldName].status = "changed";
    // Usually, there are child fields whose status was just set to "changing". But there's a chance that none of them
    // are present on the form, in which case we should unblock the form. Check for that condition now.
    checkForCompletionOfDependencyProcessing($container, fieldDeps);
    $controlField.trigger("controlFieldChanged");
  }


  /**
   * Check if any parent fields have status == changing/being processed. If so, just return w/o doing anything.
   * Check if all parent fields have status == unchanged. If so:
   *  skip processing the dependencies for this field
   *  set the status of this field to “unchanged”
   *  still trigger a controlFieldChanged event on itself, as there may be children that have other parents that did change, and are depending on this event

   * Process the dependencies
   *   (for all parents that have status=changed) --> process that dependency type
   * If the value and visibility of this field did not change, set its status to “unchanged”. Otherwise, set it to “changed”
   * If it has dependent fields, trigger a controlFieldChanged event on itself
   *    this is done down deeper in the code that regenerates & replaces options, as that happens asynchronously
   * If it does not have dependent fields, check to see if any fields on the form have status=changing/being processed. If not, unblock
   *  the form and set all fields' statuses to ““ (so that they do not impact future determinations - which they may if
   *  they are a parent of a field that is processing a change event)
  */
  function controlFieldChanged($container, $dependentField, dependentFieldName, depInfo, fieldDeps) {
    logger.debug("In controlFieldChanged, an upstream field for dependent field", dependentFieldName, "changed. depInfo =", depInfo);

    let shouldRegenOptions = false;
    let shouldShowHide = false;
    let shouldPluginShowHide = false;
    let anyControllingFieldChanged = false;
    let hasAnyRegenDependency = false;
    for (let [controllingFieldName, controllingFieldInfo] of Object.entries(depInfo.controlling_fields)) {
      const controllingFieldStatus = fieldDeps[controllingFieldName].status;
      logger.debug(" Status of controlling field", controllingFieldName, "is '" + controllingFieldStatus + "'");
      // Keep track of whether it has any regen dependencies (even on fields that didn't change). If so, we'll need to
      // regen options if the field goes from hidden to visible.
      hasAnyRegenDependency = hasAnyRegenDependency || (controllingFieldInfo.regenoptions != undefined);
      if (controllingFieldStatus == "changing" || controllingFieldStatus == "being processed") {
        logger.debug("Skipping processing", dependentFieldName, "for now as at least one of the controlling fields (" + controllingFieldName + ") is still", controllingFieldStatus);
        return;
      }
      if (controllingFieldStatus == "changed") {
        anyControllingFieldChanged = true;
        // Check if any are regen options
        if (controllingFieldInfo.showhide != undefined) {
          shouldShowHide = true;
        }
        // Plugin-backed show/hide is decided by the back end (the plugin cannot run in the
        // browser), so flag it for a server round-trip in updateDependentField().
        if (controllingFieldInfo.pluginshowhide != undefined) {
          shouldPluginShowHide = true;
        }
        if (controllingFieldInfo.regenoptions != undefined) {
          shouldRegenOptions = true;
        }
      }
    }
    const dependentFieldStatus = fieldDeps[dependentFieldName].status;
    logger.debug(" Status of dependent field", dependentFieldName, "is '" + dependentFieldStatus + "'");
    if (dependentFieldStatus != "changing") {
      logger.debug(" Something already seems to be processing/have processed this field. Skipping processing it.");
      return;
    }
    // Updating this field's status from "changing" to "being processed" acts as a primitive lock and "claims" this
    // dependent field for this executing change handler. Otherwise, the timing of the change handlers firing for
    // multiple controlling fields sometimes causes double processing of this dependent field (when the controlling
    // fields have all already been set to changed/unchanged).
    fieldDeps[dependentFieldName].status = "being processed";

    if (!anyControllingFieldChanged) {
      logger.debug(" None of the controlling fields for", dependentFieldName, "changed. Will skip updating this field, but propagate the change event if it has dependent fields.");
      fieldDeps[dependentFieldName].status = "unchanged";
      finishChangingField(depInfo, $dependentField, $container, fieldDeps);
    } else {
      updateDependentField($dependentField, dependentFieldName, depInfo, $container, shouldShowHide, shouldRegenOptions, hasAnyRegenDependency, fieldDeps, shouldPluginShowHide);
    }
  }

  /*
   * Return a CSS selector that uniquely matches $field, for use with jQuery event delegation.
   */
  function getFieldSelector($field) {
    const id = $field.attr('id');
    if (id) {
      return '#' + $.escapeSelector(id);
    }
    return '[name="' + $field.attr('name') + '"]';
  }

  /*
   * Set up change handlers for all controlling & dependent fields.
   *
   * These are bound via delegation on $container (rather than directly on the field elements)
   * because regenerating a field's options (regenOptionsForField() -> replaceFieldOptions())
   * calls selectize.destroy() on the field, which strips all directly-bound jQuery event data
   * off of it before rebuilding it. A field that is both a dependent field (its options get
   * regenerated) and a controlling field for something else would silently lose its
   * 'controlFieldChanged' (and user-driven change/slideStop) handlers the first time its own
   * options were regenerated, permanently breaking the cascade to its dependents.
   */
  function createChangeHandlersForFieldDependencies(fieldDeps, $container) {
    for (let [fieldName, depInfo] of Object.entries(fieldDeps)) {
      const $field = getField(fieldName, $container);
      if (!$field) {
        // It wasn't found, mark it as missing so we do not wait for it when checking if processing is complete.
        fieldDeps[fieldName].status = "missing";
        continue;
      }
      if (depInfo.dependent_fields) {
        logger.debug("Creating 'controlFieldChangedByUser' change handler on controlling field", $field.attr('id'), "(" + fieldName + ")");
        // trigger this on "dependentFields.changed" or "change" events (or "slideStop", for slider controlling fields)
        const eventName = getChangeEventForField($field);
        $container
          .on(eventName, getFieldSelector($field), { fieldName: fieldName, depInfo: depInfo, fieldDeps: fieldDeps}, function (e) {
            // fieldName, etc are passed in as extra `data` on the event
            // Technique gracefully supplied by: https://stackoverflow.com/a/15904419/5754160
            controlFieldChangedByUser($container, $(this), e.data.fieldName, e.data.depInfo.dependent_fields, e.data.fieldDeps);
          });
      }
      if (depInfo.controlling_fields) {
        for (let controllingFieldName of Object.keys(depInfo.controlling_fields)) {
          const $controllingField = getField(controllingFieldName, $container);
          if (!$controllingField) {
            // It wasn't found, mark it as missing so we do not wait for it when checking if processing is complete.
            fieldDeps[controllingFieldName].status = "missing";
            continue;
          }

          logger.debug("Creating 'controlFieldChanged' change handler on controlling field", $controllingField.attr('id'), "for dependent field", fieldName);
          $container
              .on('controlFieldChanged', getFieldSelector($controllingField), {
                field: $field,
                fieldName: fieldName,
                depInfo: depInfo,
                fieldDeps: fieldDeps
              }, function (e) {
                // field, etc are passed in as extra `data` on the event
                // Technique gracefully supplied by: https://stackoverflow.com/a/15904419/5754160
                controlFieldChanged($container, e.data.field, e.data.fieldName, e.data.depInfo, e.data.fieldDeps);
              });
        }
      }
    }
  }

  /*
   * Return the event name this field triggers and which should cause dependent fields to be shown
   * or hidden.
   */
  function getChangeEventForField($field) {
    const $slider = $field.closest('.form-group').find('.slider');
    if ($slider.length) {
      return 'slideStop';
    }

    // For most fields we can just observe 'change'
    return 'change';
  }

  function getFieldValue($field) {
    let fieldValue;
    if ($field.is(':checkbox')) {
      fieldValue = $field.prop('checked');
    } else {
      fieldValue = $field.val();
    }
    // logger.debug('  Value of field', $field + ':', fieldValue)
    return fieldValue;
  }

  function isControlMatching(values, controlValue, $control_field) {
    // In some cases, the boolean field is actually a drop-down string field on the form, so
    // look for the string equivalents of the booleans as well.
    // logger.debug('  Values for', $control_field, 'for which to show dependent field:', values)

    if (values.indexOf(true) != -1 && values.indexOf("True") == -1) {
      values.push("True");
    }
    if (values.indexOf(false) != -1 && values.indexOf("False") == -1) {
      values.push("False");
    }

    let controlMatch;
    const matchAnyValue = values.length === 0
    if (matchAnyValue) {
      // Consider the value matching if it is anything not blank or "False"
      // controlValue.length checks for both empty string and empty array
      controlMatch = controlValue !== null && controlValue.length !== 0 && controlValue != "False"
    } else {
      let controlValues;
      const controlDelimiter = $control_field.data('delimiter');
      if (Array.isArray(controlValue)) {  // multi-select input case
        controlValues = controlValue;
      } else if (controlDelimiter !== undefined) {
        controlValues = controlValue.split(controlDelimiter);
      } else {
        controlValues = [controlValue]
      }

      // Make controlMatch true if any of the controlValues match
      controlMatch = controlValues.some(function(controlValue) {
        return (
          // String or boolean case
          ($.inArray(controlValue, values) !== -1) ||
          // Ints and floats need to be explicitly handled
          // since we are casting all values to strings in common/fields.py
          ($.inArray(parseInt(controlValue), values) !== -1) ||
          ($.inArray(parseFloat(controlValue), values) !== -1)
        );
      });
    }
    // logger.debug('  Found a match:', controlMatch)
    return controlMatch;
  }

  function showOrHideField(show_dependent_field, $dependent_field) {
    // Now hide or show the dependent field. Also immediately mark this field's visibility using
    // a custom data attr. This ensures c2.orderForm.validateRequiredField has the correct info
    // needed for formset validation.
    var className = '.form-group';
    var controlName = '.controls';
    if (cuiMode) {
      className = '.input-group';
      controlName = '.form-group';
    }

    const $formGroup = $dependent_field.closest(className);
    if (show_dependent_field) {
      // logger.debug('  Showing dependent field ', $dependent_field.name)
      // Show the dependent field, fading in slowly enough that users notice
      $formGroup.data('dependent-field-visible', true).fadeIn(400);
      const $formControl = $dependent_field.closest(controlName);
      if (!cuiMode) {
        $formControl.css('overflow', 'visible');
      } else {
        $formControl.css('display', '');
      }

      $dependent_field.prop('disabled', false);
      $dependent_field.data('is-visible', true);

      // From now on, this field will be faded out rather than hidden immediately.
      $dependent_field.data('dependent-field-seen', true);
    } else {
      // logger.debug('  Hiding dependent field ', $dependent_field.name)
      $formGroup.data('dependent-field-visible', false);

      // Either hide this dependent field immediately (first render of form) or
      // fade it out to indicate the form is morphing.
      if ($dependent_field.data('dependent-field-seen')) {
        $formGroup.fadeOut(400);
      } else {
        $formGroup.hide();
      }

      // Do not let hidden fields be submitted
      $dependent_field.prop('disabled', true);
      $dependent_field.data('is-visible', false);

      // Clear any errors on the dependent field to allow form submission.
      $dependent_field.parents('.has-error').removeClass('has-error');
    }
  }

  /**
   * Handle all dependency types for one dependent field when a controlling field changes.
   * It wisely determines whether the field is hidden and skips regenerating its options if so.
   * @param {Object} depInfo
   * @param {Object} depInfo.controlling_fields - has a key for each controlling field, with
   * @param {Array} depInfo.dependent_fields - a list of names of dependent fields
    */
  function updateDependentField($dependentField, dependentFieldName, depInfo, $container, shouldShowHide, shouldRegenOptions, hasAnyRegenDependency, fieldDeps, shouldPluginShowHide) {
    logger.debug('Processing one or more dependencies for dependent field', dependentFieldName);

    const wasShown = !($dependentField.prop('disabled'));

    if (shouldPluginShowHide) {
      // Visibility is decided by a back-end plugin (the plugin cannot run in the browser).
      // Evaluate it via AJAX; the success/error handlers take responsibility for showing or
      // hiding the field and finishing the change processing. Plugin-backed dependent fields
      // have no regen/static-showhide dependency, so we handle this case exclusively.
      logger.debug(' Evaluating plugin-backed show/hide for dependent field', dependentFieldName);
      evaluatePluginVisibility($dependentField, dependentFieldName, depInfo, $container, wasShown, fieldDeps);
      return;
    }

    let nowShown = wasShown;
    if (shouldShowHide) {
      // Note that determining whether the field should be hidden does not take into account which of the controlling
      // fields changed. If there are >1 control fields, the decision will be based on all of their current values.
      logger.debug(' Checking show/hide conditions for dependent field', dependentFieldName);
      nowShown = checkShowHideConditions($dependentField, depInfo.controlling_fields, $container);
    }
    let optionsRegenerated = false;
    const showHideChanged = (wasShown != nowShown);

    if (nowShown) {
      // Regenerate options, but (only if a regen dependency was triggered for this field) OR the field was hidden and now is shown and has any regen dependency.
      // We regenerate options in that last case as they may otherwise be stale.
      if (shouldRegenOptions || (!wasShown && hasAnyRegenDependency)) {
        // Note that the regeneration of options does not take into account which of the controlling fields
        // changed. If there are >1 control fields, the regeneration will be based on all of their current values.
        logger.debug(' Regenerating options for dependent field', dependentFieldName);
        regenOptionsForField($dependentField, dependentFieldName, $container, showHideChanged, depInfo, fieldDeps);
        // The regeneration happens asynchronously, so it may not be complete yet, but we want to make sure we do not
        // fire a change event if regenOptionsForField() was called as it will take care of that when it is done.
        optionsRegenerated = true;
      }
    }

    if (!optionsRegenerated) {
      if (showHideChanged) {
        // This field went from either being shown to hidden or vice versa, and regenOptionsForField() was not called.
        depInfo.status = "changed";
      } else {
        depInfo.status = "unchanged";
      }

      finishChangingField(depInfo, $dependentField, $container, fieldDeps);
    }
  }

  /**
   @description - Check if $dependentField should be shown or hidden and do it
   @return {boolean} - whether the field is shown
   @param $dependentField - the field object in the DOM to be shown/hidden
   @param {Object} controllingFields - has a keys for each controlling field, like this:
    {'bp_param_207': {'showhide': {'is_not': ['207-opt1']},
                      'regenoptions': true},
     'bp_param_208': {'regenoptions': true}
    }
   @param $container - the whole form
   */
  function checkShowHideConditions($dependentField, controllingFields, $container) {
      // Iterate across the controlling fields and only show the dep field if all are matching.
      let $controllingField;
      let show_dependent_field = true;  // innocent until proven guilty
      let is_control_visible;
      for (let [controllingFieldName, controllingFieldInfo] of Object.entries(controllingFields)) {
        if (controllingFieldInfo.showhide == undefined) {
          // This control field only has a regen options dependency on this one, ignore it.
          continue;
        }
        $controllingField = getField(controllingFieldName, $container);
        if (!$controllingField || controllingFieldInfo.status == "missing") {
          continue;
        }
        is_control_visible = $controllingField.data('is-visible');
        let controlValue = "";
        if (is_control_visible == false) {
          logger.debug('  Controlling field seems to not be visible, will consider its value to be ""');
          // Q: If the controlling field isn't visible, shouldn't we just hide the dependent field? A: No, the
          // dependency may be a "Hide" dependency and specify that the field should only be shown if the controlling
          // field is blank.
        } else {
          controlValue = getFieldValue($controllingField);
        }
        if (controllingFieldInfo.showhide.is != undefined) {
          show_dependent_field = isControlMatching(controllingFieldInfo.showhide.is, controlValue, $controllingField);
          if (!show_dependent_field) {
            logger.debug('  Value of controlling field', controllingFieldName, 'is "' + controlValue + '" which is not matching, will hide dep field');
            // Stop iterating when any control is not matching and hide the dep field
            break;
          }
        }
        if (controllingFieldInfo.showhide.is_not != undefined) {
          show_dependent_field = !isControlMatching(controllingFieldInfo.showhide.is_not, controlValue, $controllingField);
          if (!show_dependent_field) {
            logger.debug('  Value of controlling field', controllingFieldName, 'is "' + controlValue + '" which is matching, will hide dep field');
            // Stop iterating when any "when not" value matches and hide the dep field
            break;
          }
        }
      }
      if (show_dependent_field) {
        logger.debug("  No reason to hide the field was found, will show it.");
      }

      showOrHideField(show_dependent_field, $dependentField);
      return show_dependent_field;
    }


  function setInitialValue(response, $newOptions, selectize_args, oldDependentValue, oldValInNewOptions, selectized_field) {
    // Set the value of the dependent field.
    let $newInit = response.initial_value;
    const noInitialValue = ($newInit === null);
    const hasOptions = (($newOptions[0] !== null) && ($newOptions[0] !== undefined));
    const isRequired = selectize_args['required']
    // logger.debug("in setInitialValue, $newInit, noInitialValue, hasOptions, isRequired =", $newInit, noInitialValue, hasOptions, isRequired)

    // no initial value was specifically passed to us
    if (noInitialValue && hasOptions && isRequired) {
      if (oldDependentValue && oldValInNewOptions) {
        // set the value to what it was before (so we preserve the user's selection before the options were regenerated)
        $newInit = oldDependentValue;
      } else {
        // set the value to the first option
        $newInit = $newOptions[0][0]
      }
    }
    if (!noInitialValue) {
      // The user may return a tuple as the initial value, like they
      // may return a list of tuples as the options_list. So, extract
      // just the first value if this is an array.
      if (Array.isArray($newInit)) {
        $newInit = $newInit[0]
      }
      $newInit = trimIfString($newInit);
    }
    // logger.debug("Setting the value to: '"+ $newInit + "'");
    // This call to setValue is done silently by passing true so it doesn't trigger a change event
    selectized_field.setValue($newInit, true);
  }

  function replaceFieldOptions(response, $dependent_field, $formControl, oldDependentValue) {
      if (!response.error) {
        let oldValInNewOptions = false;
        // Set new options and initial value from response.
        logger.debug("In replaceFieldOptions() for", $dependent_field.attr('id'), "response: ", response);
        let $newOptions = response.options;

        // Must use c2.selectize to reset the options.
        let selectize_args = {}
        if ($dependent_field.attr('data-selectize-args') !== undefined) {
          selectize_args = JSON.parse($dependent_field.attr('data-selectize-args'));
        }
        if (!response.sort) {
          // This trick for getting selectize to not auto-sort added options was found here:
          // https://github.com/selectize/selectize.js/issues/218#issuecomment-67996517
          selectize_args.sortField = [[]]
          // logger.debug("In replaceFieldOptions(), response.sort is", response.sort, "so not sorting the values.")
        }
        if ($dependent_field.length > 0 && $dependent_field[0].selectize !== undefined) {
          $dependent_field[0].selectize.destroy();
        }
        selectize_args.options = []
        // Then loop through the new options adding the new options to selectize. Trim any extra white space from ends.
        $.each($newOptions, function (key, value) {
          const val = trimIfString(value[0]);
          const text = trimIfString(value[1]);
          if (oldDependentValue == val) {
           oldValInNewOptions = true;
          }
          selectize_args.options.push({value: val, text: text});
        });
        selectize_args.selectOnTab = true
        logger.debug("In replaceFieldOptions(), selectize_args: ", selectize_args)
        let selectized_field = c2.selectize($dependent_field, selectize_args);

        // We don't want anything to generate additional change events, so we can
        // have complete control over when the change event is triggered
        // once we're ready for it to be. To accomplish this, add an event handler
        // that's first that prevents any change events from actually doing anything
        var ignore_listener = function (event) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
        // Credits to
        // https://stackoverflow.com/questions/2360655/jquery-event-handlers-always-execute-in-order-they-were-bound-any-way-around-t/2641047#2641047
        $.fn.bindFirst = function (name, fn) {
          this.on(name, fn);

          this.each(function () {
            let handlers = $._data(this, 'events')[name.split('.')[0]]
            // take out the handler we just inserted from the end
            let handler = handlers.pop();
            // move it at the beginning
            handlers.splice(0, 0, handler);
          });
        }
        $dependent_field.bindFirst('change', ignore_listener);
        setInitialValue(response, $newOptions, selectize_args, oldDependentValue, oldValInNewOptions, selectized_field);

        // Keep Selectize dropdowns from being obscured
        $formControl.css("overflow", "visible");
      } else {
        // Show error message which may contain markup, e.g. XML, so escape it using `text`.
        const msg = $('<div class="alert alert-danger" role="alert"></div>').text(response.error);
        logger.debug(msg);
        $formControl.html(msg);
      }
      // We also need to allow change handlers to function again
      $dependent_field.off('change', ignore_listener);
    }

  function serializeFormData($dependent_field, $dfName) {
    // Add the environment to the formData, because it may be disabled and won't be serialized in that case.
    const $serviceItem = $dependent_field.closest('.service-item');
    const $envField = $serviceItem.find('select[name$="-environment"]');
    let envFieldDisabled = false;

    // Enable the environment form field temporarily so that it gets included in the form data
    if ($envField.prop('disabled')) {
      envFieldDisabled = true;
      $envField.prop('disabled', false);
    }

    // Serialize the form data
    const $form = $dependent_field.closest('form');
    let formData = $dependent_field.closest('form').serializeArray();
    const metadata = '_metadata';
    formData = formData.filter(function (d) {
      if (!d.name.includes(metadata)) {
        return d;
      }
    });
    const $action = $form.prop('action');

    // Re-disable the environment field.
    if (envFieldDisabled) {
      $envField.prop('disabled', true);
    }

    // Include the "form-prefix" in the data that is sent along to the plug-in to regen options, so that plug-in
    // can look for the form data by that prefix and also strip out the prefix
    let formPrefix = $dependent_field.attr('name').replace($dfName, '');
    // delete the trailing dash to be consistent with the django form prefix attribute
    formPrefix = formPrefix.replace(/-$/, '');

    formData.push({name: "form-prefix", value: formPrefix});
    formData.push({name: "form-action", value: $action});

    return formData;
  }

    /*
      Batches up the current form selections for submission to the back-end,
      then gets the correct options for the dependent field, based on those
      selections. Then trigger the appropriate change event for the field, if anything changed. This function
      takes responsibility for sending a change event if the show/hide status changed, even if the regeneration of
      options did not change the currently selected value. This is because that signal should only be sent after the
      AJAX call is complete, and only this function knows when that call has finished.
    */
    function regenOptionsForField($dependentField, $dfName, $container, showHideChanged, depInfo, fieldDeps) {
      // Save the old value so we can check if it changed before triggering a change event
      const oldDependentValue = getFieldValue($dependentField);
       const inlineSpinnerEl = $dependentField.next('.selectize-control').length > 0 ? $dependentField.next('.selectize-control') : $dependentField.closest('div');

      c2.spinners.showInlineSpinner({element: inlineSpinnerEl});
      // Find the the div containing the .controls class that is closest to the dependent field for selectize.
      const $formControl = $dependentField.closest('.controls');
      const formData = serializeFormData($dependentField, $dfName);
      const url = '/regenerate_options_for_field/' + $dfName + '/?' + $.param(formData);
      logger.debug(' Calling this URL to regenerate options for', $dfName + ":" , url);

      // AJAX Call for get the new regenerated options.
      // Note that we do not include the control fields since the back end can determine them by querying the DB, and
      // we do not include the control values as the back end can extract them from the form data (or, if not present
      // there, from the default values provided by the group, env, etc)
      // We make this call asynchronously as we do not want to block the UI until this call is complete (including
      // closing the drop-down of options for the controlling field, etc). However, we have to wait until the call is
      // complete to send any change signals, so we do that in postReplaceFieldOptions().
      $.ajax({
           async: true,
           type: 'GET',
           url: url,
           success: function(response) {
              c2.spinners.hideInlineSpinner({element: $dependentField.closest('div')})
              replaceFieldOptions(response, $dependentField, $formControl, oldDependentValue);
              postReplaceFieldOptions($container, $dependentField, $dfName, oldDependentValue, showHideChanged, depInfo, fieldDeps);
              if ($dfName == "alibaba_disk_category") {
                if (response.options.length != 0) {
                  $(".alibaba-disk-unavailable").hide();
                }
                else {
                  let formdata_instance_type = formData.filter(obj => {
                    return obj.name === "instance_type"
                  })[0];
                  let formdata_zone = formData.filter(obj => {
                    return obj.name === "zone"
                  })[0];
                  $(".alibaba-disk-unavailable").show();
                  $(".alibaba-disk-unavailable").html(`
                    <div class="alert alert-block alert-danger">
                      <ul>
                        <li>The disk category for the <b>${formdata_instance_type.value}</b> instance type in the <b>${formdata_zone.value}</b> region is currently unavailable.</li>
                      </ul>
                    </div>
                  `);
                }
              }
           }
      });
    }

  /*
    Asks the back end whether a plugin-backed (PLUGINSHOWHIDE) dependent field should be shown,
    given the current form selections, then shows/hides it accordingly. The decision is made by
    running a plugin server-side, so this cannot be done in the browser like static show/hide.
    This function takes responsibility for finishing the change processing (firing a change event
    if the show/hide status changed and checking for completion), since that can only happen once
    the AJAX call returns. Mirrors regenOptionsForField()'s async completion handling.
  */
  function evaluatePluginVisibility($dependentField, $dfName, depInfo, $container, wasShown, fieldDeps) {
    const formData = serializeFormData($dependentField, $dfName);
    const url = '/evaluate_field_visibility/' + $dfName + '/?' + $.param(formData);
    logger.debug(' Calling this URL to evaluate plugin visibility for', $dfName + ":", url);

    // Optimistic clear (CMP-4069): drop any prior hint immediately so a rapid
    // controlling-field change never leaves a stale hint visible while the
    // round-trip is in flight. The success handler re-renders the current hint.
    setHint($dependentField, null);

    $.ajax({
      async: true,
      type: 'GET',
      url: url,
      success: function (response) {
        finishPluginVisibility($dependentField, $dfName, $container, wasShown, !!response.show, depInfo, fieldDeps, response.hint);
      },
      error: function () {
        // Fail open: show the field so a back-end error never traps it in a hidden state.
        // Provision-time validation remains the safety net for stale OCPU/memory values.
        logger.debug(' Plugin visibility evaluation failed for', $dfName, '- showing the field (fail-open).');
        finishPluginVisibility($dependentField, $dfName, $container, wasShown, true, depInfo, fieldDeps, null);
      }
    });
  }

  /*
    Render (or clear) the dynamic hint a plugin-backed field may emit (CMP-4069).
    The hint is an opaque display string supplied by the visibility plugin. The
    hint element is created lazily inside the field's form group and is an
    aria-live region so screen readers announce the hint when it appears. A falsy
    hintText clears and hides it -- which is also the correct initial state before
    any controlling value is chosen, since no element exists yet.
  */
  function setHint($dependentField, hintText) {
    let $group = $dependentField.closest('.form-group, .control-group');
    if (!$group.length) { $group = $dependentField.parent(); }
    let $hint = $group.find('.field-hint');
    if (!hintText) {
      if ($hint.length) { $hint.text('').hide(); }
      return;
    }
    if (!$hint.length) {
      $hint = $('<small class="field-hint help-block" role="status" aria-live="polite"></small>');
      $dependentField.after($hint);
    }
    $hint.text(hintText).show();
  }

  /*
    The plugin visibility AJAX call returned. Show or hide the field and set depInfo.status based
    on whether its visibility changed, then finish (propagate a change event to its own dependent
    fields if needed and check whether the whole form is done processing).
  */
  function finishPluginVisibility($dependentField, $dfName, $container, wasShown, nowShown, depInfo, fieldDeps, hint) {
    showOrHideField(nowShown, $dependentField);
    // Show the hint only while the field is visible; clear it when hidden.
    setHint($dependentField, nowShown ? hint : null);
    if (wasShown != nowShown) {
      depInfo.status = "changed";
      logger.debug('Marking', $dfName, 'as changed since its plugin-backed show/hide status changed.');
    } else {
      depInfo.status = "unchanged";
      logger.debug('Marking', $dfName, 'unchanged as its plugin-backed show/hide status did not change.');
    }
    finishChangingField(depInfo, $dependentField, $container, fieldDeps);
  }

  function checkForCompletionOfDependencyProcessing($container, fieldDeps) {
    for (let [fieldName, depInfo] of Object.entries(fieldDeps)) {
      if (depInfo.status == "changing" || depInfo.status == "being processed") {
        return;
      }
    }
    logger.debug("All fields are done processing. Unblocking the form.");
    // First set the status of all fields on the form to "". This is to prevent a leftover "changed" status from
    // affecting the behavior if a user modifies a node in the dependency graph with a common child with one of these.
    for (let [fieldName, depInfo] of Object.entries(fieldDeps)) {
      if (depInfo.status != "missing") {
        depInfo.status = "";
      }
    }
    // Anytime we finish processing field dependencies, call updateFormState to enable/disable the submit button
    // based on the new state of the form.
    c2.orderForm.updateFormState();
  }

  /**
   * Now that this field is done changing, check to see if it has dependent fields and trigger a "controlFieldChanged"
   * event if so. In either case, check to see if the entire form is done processing and unblock it if so.
   */
  function finishChangingField(depInfo, $dependentField, $container, fieldDeps) {
    if (depInfo.dependent_fields) {
      // This dependent field is also a controlling field, trigger a change event so its children are processed
      logger.debug('Triggering "controlFieldChanged" for', $dependentField, 'since there are fields that depend on it');
      $dependentField.trigger("controlFieldChanged");
    }
    // Since this field has finished updating, check to see if all fields are finished, and unblock the form if so.
    // This check is superfluous but not harmful if the field has some dependent fields that are still processing. We
    // cannot know just by the presence of depInfo.dependent_fields that it has child nodes - it may have
    // dependent_fields that are not on the form (e.g. when configuring an environment on a PSSI and some fields have
    // been removed because they are also BP params).
    checkForCompletionOfDependencyProcessing($container, fieldDeps);
  }

  /**
   * A field's options were regenerated. Determine if the currently selected option changed, and set depInfo.status
   * accordingly. Then call finishChangingField() to trigger a controlFieldChanged event as appropriate and check if
   * we are done processing all dependencies.
  */
  function postReplaceFieldOptions($container, $dependentField, $dfName, oldDependentValue, showHideChanged, depInfo, fieldDeps) {
        const newDependentValue = getFieldValue($dependentField);
        if (oldDependentValue != newDependentValue) {
          depInfo.status = "changed";
          logger.debug('Marking', $dfName, 'as changed since its value changed after regenerating options.');
        } else {
          if (showHideChanged) {
            // Even though the value of our field did not change, if it changed from hidden to shown, it is our
            // responsibility to trigger a change event now that the call to regen options has returned and we are done.
            // Trigger a custom 'dependentFields.changed' event on the dependent field to show/hide any nested dependent
            // fields that use it as controlling field (but this will not trigger orderForm.updateFormIfFieldChanged() to
            // update the error state and submit button).
            depInfo.status = "changed";
            logger.debug('Marking', $dfName, 'as changed since its show/hide status changed (even though the value of the field did not change after regenerating options).');
            // $dependentField.trigger('dependentFields.changed', ['normal'])
          } else {
            depInfo.status = "unchanged";
            logger.debug('Marking', $dfName, 'unchanged as its value did not change after regeneration nor did its hidden status.');
          }
        }
    finishChangingField(depInfo, $dependentField, $container, fieldDeps);
  }

  function getField($fieldName, $container) {
    let $field = $container.find('[name="' + $fieldName + '"]');
    if ($field.length !== 0) {
      return $field;
    }
    // The exact lookup of the name did not find anything. Now look for the field with a name that ends with "-$<fieldName>"
    // In service item forms, the names are prependend with "form-<num>-", so we attempt to look them up this way.
    // In the future, this function could accept the form prefix as an argument and look it up by the exact name.
    $field = $container.find('[name$="-' + $fieldName + '"]');
    if ($field.length !== 0) {
      return $field;
    }
    // It's possible that this field name is a multi-field field (like password, which has two inputs appended with _0 and _1)
    // In this case, the field name we want is appended with "_0". That'll usually allow anything using this to select the field's
    // containing div to show/hide it (for example).
    $field = $container.find('[name$="-' + $fieldName + '_0"]');
    if ($field.length !== 0) {
      return $field;
    }
    console.warn("Could not find field with name", $fieldName);
  }

  c2[__module__] = {
    init: init
  }

})('dependentFields');
